module.exports = __webpack_public_path__ + "fonts/UTM-Eremitage.0264ca8.ttf";